import React from "react";
import { Box, Typography, Grid, Container, Divider } from "@mui/material";
import wadirum from '../assets/Cairo3.jpg';
//E:\demo_website\demo_website\src\assets\Nuweiba 3.jpg
import { useTranslation } from "react-i18next";
const AboutUs = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  return (
    <Container maxWidth="md" sx={{ py: 4 ,backgroundColor: '#ffffff',width: '100%',minWidth: '100%'}}>
         <Box
      sx={{
        flexDirection: 'column',
        position: "relative",
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        backgroundColor: "transparent",
      }}
    >
      {/* Fixed Background */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage: `url(${wadirum})`, // ✅ Fix background image
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          zIndex: -1, // ✅ Sends it behind the text
        }}
      />
      <Box py={5}marginInline={{ md: 19, xs: 1 }}>
        {/* Heading */}

        {/* Content Section */}
        <Grid container spacing={4} alignItems="start">
          {/* Text Content */}
          <Grid item xs={12} md={8} >
        <Typography variant="h4" fontWeight="bold" gutterBottom sx={{ fontFamily: 'Montserrat' ,margin:   {xs: '20px auto', md: '20px 0'},textAlign: { xs: 'center', md: isRTL ? 'right' : 'left' }}}>
          {t('Titles.about_us')}
        </Typography>
        <Divider sx={{ backgroundColor: 'primary.main', width: '10vh', height: '3px' ,margin: { xs: '20px auto', md: isRTL ? '20px 0 20px auto' : '20px auto 20px 0'} }} />
            <Typography variant="body1" component="p" color="#5a5c61" sx={{lineHeight: '2', fontFamily: 'Noto Sans',textAlign: { xs: 'center', md: isRTL ? 'right' : 'left' }}}>  
            {t('Descriptions.about_us')}
            </Typography>
            <Typography variant="body1" component="p" color="#5a5c61" sx={{lineHeight: '2', fontFamily: 'Noto Sans',textAlign: { xs: 'center', md: isRTL ? 'right' : 'left' } }}>
            {t('Descriptions.about_us_2')}
            </Typography>
            <Typography variant="body1" component="p" color="#5a5c61" sx={{lineHeight: '2', fontFamily: 'Noto Sans',textAlign: { xs: 'center', md: isRTL ? 'right' : 'left' }  }}>
            {t('Descriptions.about_us_3')}
            </Typography>
            <Typography variant="body1" component="p" color="#5a5c61" sx={{lineHeight: '2', fontFamily: 'Noto Sans',textAlign: { xs: 'center', md: isRTL ? 'right' : 'left' }  }}>
            {t('Descriptions.about_us_4')}
            </Typography>
            <Typography variant="body1" component="p" color="#5a5c61" sx={{lineHeight: '2', fontFamily: 'Noto Sans',textAlign: { xs: 'center', md: isRTL ? 'right' : 'left' }  }}>
            {t('Descriptions.about_us_5')}
            </Typography>
            <br />
            <Typography variant="body2" fontWeight="bold" sx={{lineHeight: '2', fontFamily: 'Noto Sans',textAlign: { xs: 'center', md: isRTL ? 'right' : 'left' }  }}>
              {t('Titles.best')}
              <br />
              {t('Titles.Name')}
              <br />
              {t('Titles.Title')}
              <br />
              {t('Titles.Location')}
            </Typography>
          </Grid>

          {/* Logo Section */}
          <Grid item xs={12} md={4} display="flex" justifyContent="center" alignItems="start">
            <img
              src="/logo-Photoroom.png"  // Replace with your actual logo path
              alt="Peace Way Tours Logo"
              style={{ width: "100%", maxWidth: 150,backgroundColor: '#13294b' ,borderRadius: '50%'}}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
    </Container>
  );
};

export default AboutUs;
